import { VueRegistration } from "@abaco/web-common/src/app";

const globals: VueRegistration = {
    FarmSelectNavBarItem: () => import("./components/navbar/farm-select/FarmSelectNavBarItem.vue"),
    CampaignSelectNavBarItem: () => import("./components/navbar/campaign-select/CampaignSelectNavBarItem.vue"),
    SCLeaderSelectNavBarItem: () => import("./components/navbar/SCLeaderSelectNavBarItem.vue"),
    CouncilSelectNavBarItem: () => import("./components/navbar/council-select/CouncilSelectNavBarItem.vue"),
    ProvinceSelectNavBarItem: () => import("./components/navbar/province-select/ProvinceSelectNavBarItem.vue"),

    FarmRegistyListTile: () => import("./components/tiles/registry/FarmRegistyListTile.vue"),
    FarmRegistrySelectCouncil: () => import("./components/FarmRegistrySelectCouncil.vue"),
    FarmRegistrySelectPartyCouncil: () => import("./components/FarmRegistrySelectPartyCouncil.vue"),
    FarmNewTile: () => import("./components/tiles/registry/FarmNewTile.vue"),
    FarmEditTile: () => import("./components/tiles/registry/FarmEditTile.vue"),
    FarmLocationMap: () => import("./components/tiles/registry/FarmLocationMap.vue"),
    FarmRegistryNewParty: () => import("./components/tiles/registry/FarmRegistryNewParty.vue"),
    FarmRegistryHome: () => import("./components/tiles/registry/FarmRegistryHome.vue"),

    FarmOrganizationTile: () => import("./components/tiles/FarmOrganizationTile.vue"),

    FarmInvolvedContainer: () => import("./components/FarmInvolvedContainer.vue"),
    InvolvedRoleWorkers: () => import("./components/tiles/involved/InvolvedRoleWorkers.vue"),
    InvolvedRoleWorkersPassive: () => import("./components/tiles/involved/InvolvedRoleWorkersPassive.vue"),
    InvolvedWorkerTile: () => import("./components/tiles/involved/InvolvedWorkerTile.vue"),
    InvolvedRoleLabor: () => import("./components/tiles/involved/InvolvedRoleLabor.vue"),

    FarmEditLegalRoleList: () => import("./components/tiles/registry/farmEditTabs/FarmEditLegalRoleList.vue"),
    FarmEditUsers: () => import("./components/tiles/registry/farmEditTabs/FarmEditUsers.vue"),

    DocumentsCategoryListTile: () => import("./components/tiles/documents/DocumentsCategoryListTile.vue"),
    DocumentsCategoryList: () => import("./components/tiles/documents/DocumentsCategoryList.vue"),
    DocumentsCategoryListComponent: () => import("./components/tiles/documents/DocumentsCategoryListComponent.vue"),
    DocumentEditPage: () => import("./components/tiles/documents/DocumentEditPage.vue"),
    DocumentEditModal: () => import("./components/tiles/documents/DocumentEditModal.vue"),
    DocumentsIframe: () => import("./components/tiles/documents/DocumentsIframe.vue"),
};

export default globals;
